(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mae-global-portal"]) return;
  try {
    
  if (!document.documentElement.dataset.maeGlobalPortalReady) {
    document.documentElement.dataset.maeGlobalPortalReady = 'true';

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');

      if (!link || event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (link.target === '_blank' || link.hasAttribute('download')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const destination = new URL(link.href, window.location.href);
      const current = new URL(window.location.href);
      const isInternal = destination.origin === current.origin;
      const isSameHash = destination.pathname === current.pathname && destination.search === current.search && destination.hash;
      const ignored = link.closest('form, .cart-notification, .predictive-search, .pagination');

      if (!isInternal || isSameHash || ignored) return;

      event.preventDefault();
      document.documentElement.classList.add('mae-global-portal-active');

      window.setTimeout(() => {
        window.location.assign(destination.href);
      }, 1540);
    });

    window.addEventListener('pageshow', () => {
      document.documentElement.classList.remove('mae-global-portal-active');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mae-music-player"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mae-music]').forEach((music) => {
    const player = music.querySelector('[data-mae-music-player]');
    const toggle = music.querySelector('[data-mae-music-toggle]');
    const status = music.querySelector('[data-mae-music-status]');
    const source = 'https://bandcamp.com/EmbeddedPlayer/track=4149929031/size=small/bgcol=030108/linkcol=8b5cf6/transparent=true/autoplay=true/';
    const duration = Number(music.dataset.trackDuration || 219000);
    const onLabel = 'Music on';
    const offLabel = 'Music off';
    const pauseLabel = 'Pause background music';
    const playLabel = 'Play background music';
    let enabled = true;
    let loopTimer;
    let interactionRetryComplete = false;

    const stopLoop = () => window.clearTimeout(loopTimer);

    const start = () => {
      if (!enabled) return;
      stopLoop();
      player.src = source;
      loopTimer = window.setTimeout(start, duration);
    };

    const stop = () => {
      stopLoop();
      player.src = 'about:blank';
    };

    start();

    const retryAfterInteraction = () => {
      if (interactionRetryComplete || !enabled) return;
      interactionRetryComplete = true;
      start();
    };

    document.addEventListener('pointerdown', retryAfterInteraction, { once: true, passive: true });
    document.addEventListener('keydown', retryAfterInteraction, { once: true });

    toggle.addEventListener('click', () => {
      enabled = !enabled;
      toggle.setAttribute('aria-pressed', String(enabled));
      toggle.setAttribute('aria-label', enabled ? pauseLabel : playLabel);
      status.textContent = enabled ? onLabel : offLabel;
      if (enabled) start();
      else stop();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mae-world-arrival"] && !Shopify.designMode) return;
  try {
    
  const playMaeArrivals = () => {
    document.querySelectorAll('[data-mae-arrival]').forEach((arrival) => {
      const world = arrival.dataset.maeArrival;
      window.clearTimeout(Number(arrival.dataset.dismissTimer || 0));
      arrival.hidden = false;
      arrival.classList.remove('is-leaving');

      arrival.getAnimations({ subtree: true }).forEach((animation) => {
        animation.cancel();
        animation.play();
      });

      const dismiss = () => {
        arrival.classList.add('is-leaving');
        window.setTimeout(() => {
          arrival.hidden = true;
        }, 500);
      };

      if (arrival.dataset.skipBound !== 'true') {
        arrival.querySelector('.mae-arrival__skip')?.addEventListener('click', dismiss);
        arrival.dataset.skipBound = 'true';
      }

      arrival.dataset.dismissTimer = String(
        window.setTimeout(dismiss, world === 'sehent' ? 3100 : 3400)
      );
    });
  };

  playMaeArrivals();
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) playMaeArrivals();
  });

  } catch(e) { console.error(e); }
})();
})();
